export default __webpack_public_path__ + "images/e75c0c42a9cd45348b28ce976171119f-andy-profile-full.svg";